export function isVeriffSession(checkType) {
  const ct = (checkType || "")
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[_\s]+/g, " "); // normalise spacing/underscores

  
  // console.log("isVeriffSession", ct === "standard" || ct === "enhanced");
  return ct === "standard" || ct === "enhanced";
}
